import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { ciTypesInterface } from 'src/app/util/interfaces/ciTypes';
import { ModelService } from '../model/service/model.service';
import { MspTableComponent, mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { DotBounceLoadingEffectModule } from 'src/app/page_component_item/dot-bounce-loading-effect/dot-bounce-loading-effect.module';
import { CpuModelInterface } from 'src/app/util/interfaces/cpuModel';
import { CpuModelService } from './service/cpu-model.service';

@Component({
	selector: 'register-form-cpu-model',
	standalone: true,
	imports: [CommonModule, FormsModule, MspTableComponent, DotBounceLoadingEffectModule],
	templateUrl: './cpu-model.component.html',
	styleUrl: './cpu-model.component.scss',
})
export class CpuModelComponent implements OnInit {
	labels: any = {
		lbl_geral_selecione: 'Select',
		lbl_geral_novo: 'New',
		lbl_geral_salvar: 'Save',
		lbl_geral_voltar: 'Back',
		lbl_geral_excluir: 'Delete',
		lbl_geral_confirmar: 'Confirm',
		lbl_successful_updated: 'Successful updated',
		lbl_salvo_com_sucesso: 'Successful created',
		lbl_preencha_todos_asteriscos: 'Fill in at least the fields marked by *',
	};

	cpuModelInterface: CpuModelInterface = {
		id: undefined,
		cpu: '',
		ci_type: '',
	};

	isLoadingLabels = true;
	isLoadingCpuModels = true;

	cpuModelsList: CpuModelInterface[] = [];
	ciTypeList: ciTypesInterface[] = [];

	searchHeader: mspTableHeaderI[] = [
		{ name: 'cpu', value: 'lbl_asset_cpu', colType: 'text' },
		{ name: 'ci_type_label', value: 'lbl_asset_tipo_ci', colType: 'text' },
	];

	constructor(
		private notification: NotificationService,
		private labelsService: LabelsService,
		private modelService: ModelService,
		private cpuModelService: CpuModelService
	) {}

	ngOnInit(): void {
		this.labelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.getAllCpuModels();
		this.getAllCiType();
	}

	getAllCpuModels(): void {
		this.cpuModelService.getCpuModels().subscribe((data) => {
			this.cpuModelsList = data;
			this.isLoadingCpuModels = false;
		});
	}

	getAllCiType(): void {
		this.modelService.getAllCiType().subscribe((ciTypes) => {
			this.ciTypeList = ciTypes.filter((ciType) => {
				return ciType['table'] === 'workstations' || ciType['table'] === 'servers';
			});
		});
	}

	clearInputs(isNew: boolean): void {
		this.cpuModelInterface = {
			id: isNew ? '' : undefined,
			cpu: '',
			ci_type: '',
		};

		if (isNew === false) {
			this.isLoadingCpuModels = true;
			this.getAllCpuModels();
		}
	}

	cleanValues(): void {
		this.cpuModelInterface = {
			id: '',
			cpu: '',
			ci_type: '',
		};

		this.cpuModelsList = [];
		this.isLoadingCpuModels = true;
		this.getAllCpuModels();
	}

	validateForm(): void {
		if (this.cpuModelInterface.cpu === '' || this.cpuModelInterface.ci_type === '') {
			this.notification.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
			return;
		}

		this.save();
	}

	save(): void {
		if (this.cpuModelInterface.id) {
			this.cpuModelService.putCpuModel(this.cpuModelInterface).subscribe((data) => {
				if (data[0].status === 'Error') {
					this.notification.setNotificationMessage(this.labels.lbl_erro_nome_ja_existente);
				} else {
					this.notification.setNotificationMessage(this.labels.lbl_successful_updated);
					this.cleanValues();
					this.clearInputs(false);
				}
			});
		} else {
			this.cpuModelService.postCpuModel(this.cpuModelInterface).subscribe((data) => {
				if (data[0].status === 'Error') {
					this.notification.setNotificationMessage(this.labels.lbl_erro_nome_ja_existente);
				} else {
					this.notification.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
					this.cleanValues();
					this.clearInputs(false);
				}
			});
		}
	}

	deleteCpuModel(event: Event): void {
		if (!this.cpuModelInterface.id) return;

		if ((event.target as HTMLElement).classList.contains('double-click')) {
			this.cpuModelService.deleteCpuModels([Number(this.cpuModelInterface.id)]).subscribe((data) => {
				this.notification.setNotificationMessage(this.labels.lbl_edocs_status_excluido || this.labels.lbl_geral_excluir);
				this.cleanValues();
				this.clearInputs(false);
			});
		} else {
			(event.target as HTMLElement).classList.add('double-click');

			setTimeout(() => {
				(event.target as HTMLElement).classList.remove('double-click');
			}, 2000);
		}
	}

	openForm(item: CpuModelInterface): void {
		this.cpuModelInterface = {
			id: item.id,
			cpu: item.cpu,
			ci_type: item.ci_type,
			ci_type_label: item.ci_type_label,
		};
	}
}
